<template>
  <q-footer elevated class="bg-grey-8 text-white">
    <q-toolbar>
      <div>FacDocs Version {{ versionNumber }} {{ mode }}</div>
      <q-space />
      <div v-if="userData">{{ userData.name }} ({{ userData.email }})</div>
    </q-toolbar>
  </q-footer>
</template>

<script>
import { onMounted, ref } from 'vue';
import AuthHelper from "../helper/AuthHelper.js";
export default {
  name: "AppFooter",
  setup() {
    const versionNumber = process.env.VUE_APP_VERSION_NUMBER;
    const mode = process.env.VUE_APP_USE_DEFAULT_USER_DATA === "true" ? process.env.NODE_ENV : "";
    const userData = ref ();
    
    onMounted(() => { 
      getCurrentValues();
    })

    async function getCurrentValues() {
      userData.value = await AuthHelper.getCurrentUserData(false, false);
    } 
    return {
      versionNumber,
      mode,
      userData
    };
  }
};
</script>